module.exports = __webpack_public_path__ + "static/media/repeat.c1006587.png";